import type { ReactElement } from 'react'
import {
  AboutIcon, AccuracyIcon, BlogIcon, BuildIcon, ExploreIcon, GuidesIcon, JudgeIcon, PartnersIcon,
  PrivacyIcon, SupportIcon, WatchtowerIcon,
} from './navIcons'

// NavMenu's items. `id` keys the label (common:nav.<id>). `static: true` is a
// page OUTSIDE the SPA (prerendered /blog and /guides): NavMenu renders it as
// a plain anchor, never a router Link, which would resolve inside the app and
// fall through to Home.

export const MENU_ITEMS = [
  { path: '/collection', id: 'collection' },
  { path: '/about', id: 'about' },
  { path: '/support', id: 'support' },
  // Static page outside the SPA: a router Link would resolve inside the app
  // and 404. Full navigation via a plain anchor, same as the home blog cards.
  { path: '/blog', id: 'blog', static: true },
  // Static too, for the same reason as Blog.
  { path: '/guides', id: 'guides', static: true },
  { path: '/explore', id: 'explore' },
  { path: '/accuracy', id: 'accuracy' },
  { path: '/partners', id: 'partners' },
  { path: '/privacy', id: 'privacy' },
] as const

// Navigation v2 (plan nav-search-2026-10-16, Target): the same menu, regrouped
// into Tools / Learn / Commander Bracket. Blog and Guides keep `static: true`
// (full-page anchors) for the same reason as above. Every row has an icon:
// Tools in purple, the rest muted (NavMenu picks the tone by group). Keith
// 2026-10-31: text-only rows under an icon column read as missing icons.
type V2Item = { path: string; id: string; static?: true; Icon: (p: { className?: string }) => ReactElement }
export const MENU_GROUPS_V2: readonly { id: string; items: readonly V2Item[] }[] = [
  {
    id: 'group_tools',
    items: [
      { path: '/build', id: 'build_a_deck', Icon: BuildIcon },
      { path: '/rules', id: 'ask_the_judge', Icon: JudgeIcon },
      { path: '/explore', id: 'explore', Icon: ExploreIcon },
      { path: '/watchtower', id: 'watchtower', Icon: WatchtowerIcon },
    ],
  },
  {
    id: 'group_learn',
    items: [
      { path: '/guides', id: 'guides', static: true, Icon: GuidesIcon },
      { path: '/blog', id: 'blog', static: true, Icon: BlogIcon },
      { path: '/accuracy', id: 'accuracy_question', Icon: AccuracyIcon },
    ],
  },
  {
    id: 'group_company',
    items: [
      { path: '/about', id: 'about', Icon: AboutIcon },
      { path: '/support', id: 'support', Icon: SupportIcon },
      { path: '/partners', id: 'partners', Icon: PartnersIcon },
      { path: '/privacy', id: 'privacy', Icon: PrivacyIcon },
    ],
  },
]

